import { useSelector } from "react-redux";
import {
  IconUserCircle,
  IconCurrencyDollar,
  IconCalendarEvent,
  IconBuildingEstate,
  IconFileDescription,
  IconKey,
  IconShoppingBag,
  IconHelp,
  IconLogout,
} from "@tabler/icons-react";
import { AppStore } from "../../redux/store";
import useAuth from "../../hooks/useAuth";
import { getAppPropiSpaPath } from "../../helpers/realmHelpers";
import { DropdownContainer, DropdownItem, DropdownDivider } from "./components/NavDropdownUsers/DropdownItem";

const NavBarCustomer = () => {
  const { country } = useSelector((store: AppStore) => store.country);
  const { handleLogout } = useAuth();

  return (
    <DropdownContainer>
      <DropdownItem icon={<IconUserCircle size={22} />} href={`/app/${country}/l/ld/mi-cuenta`}>
        Mi cuenta
      </DropdownItem>
      <DropdownItem icon={<IconCurrencyDollar size={22} />} href={`${getAppPropiSpaPath()}/${country}/l/ld/payments`}>
        Mis Inversiones
      </DropdownItem>
      <DropdownItem icon={<IconCalendarEvent size={22} />} href={`${getAppPropiSpaPath()}/${country}/l/ld/pre-booking`}>
        Mis pre-reservas
      </DropdownItem>
      <DropdownItem icon={<IconBuildingEstate size={22} />} href={`${getAppPropiSpaPath()}/${country}/l/properties`}>
        Ofertas y propiedades
      </DropdownItem>
      <DropdownItem icon={<IconFileDescription size={22} />} href={`${getAppPropiSpaPath()}/${country}/l/tn/offers`}>
        Ofertas realizadas
      </DropdownItem>
      <DropdownItem icon={<IconCalendarEvent size={22} />} href={`${getAppPropiSpaPath()}/${country}/l/tn/visits`}>
        Mis visitas
      </DropdownItem>
      <DropdownItem icon={<IconKey size={22} />} href={`${getAppPropiSpaPath()}/${country}/l/tn/payments`}>
        Mis alquileres
      </DropdownItem>
      <DropdownItem icon={<IconShoppingBag size={22} />} href={`${getAppPropiSpaPath()}/${country}/l/tn/payments-sales`}>
        Mis compras
      </DropdownItem>

      <DropdownDivider />

      <DropdownItem icon={<IconHelp size={22} />} href={`${getAppPropiSpaPath()}/${country}/ayuda`}>
        Obtener ayuda
      </DropdownItem>

      <DropdownDivider />

      <DropdownItem icon={<IconLogout size={22} />} onClick={handleLogout}>
        Cerrar sesión
      </DropdownItem>
    </DropdownContainer>
  );
};

export default NavBarCustomer;
